/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect } from 'react';
import { getImageAsBase64FromS3 } from 'services/attachment';
import { useParams } from 'react-router-dom';
import Loading from 'components/atoms/Loading';
import useStyles from './style';

const Viewer = () => {
  const classes = useStyles();
  const { path } = useParams<{ path?: string }>();
  const [image, setImage] = React.useState<{ url: string; name: string }>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [ext, setExt] = React.useState<string>('');

  const videoExtension: string[] = ['mp4', 'avi'];

  const getPreSignedUrl = React.useCallback(async () => {
    if (path) {
      setLoading(true);
      try {
        const { data } = await getImageAsBase64FromS3({ path });

        const fileName = path.split('/').pop() || 'arquivo';

        const extension = path.split('.').pop()?.toLowerCase() || 'jpg';
        const isVideo = ['mp4', 'avi'].includes(extension);
        const mimeType = isVideo
          ? `video/${extension}`
          : `image/${extension === 'jpg' ? 'jpeg' : extension}`;

        setImage({
          url: `data:${mimeType};base64,${data}`,
          name: fileName,
        });
      } catch (error) {
        setImage({ url: '', name: 'Erro ao carregar' });
      } finally {
        setLoading(false);
      }
    }
  }, [path]);

  const returnExtension = React.useMemo(() => {
    if (path) {
      let extension = path.split('.').pop();
      if (extension && extension?.indexOf('?') !== -1) {
        extension = extension?.split('?')[0];
      }
      setExt(extension || 'jpg');
    }
  }, [path]);

  useEffect(() => {
    getPreSignedUrl();
  }, [getPreSignedUrl]);

  return (
    <div className={classes.container}>
      {returnExtension}
      {loading && <Loading />}
      {!loading && image && image?.url && !videoExtension.includes(ext) && (
        <img
          alt={`imagem-${image?.name}`}
          className={classes.img}
          src={image?.url}
        />
      )}
      {videoExtension.includes(ext) && image && image.url && (
        <video controls>
          <source src={image?.url} type={`video/${ext}`} />
        </video>
      )}
      {image && image.url && (
        <span className={classes.imageName}>
          {decodeURI(image && image?.name)}
        </span>
      )}
    </div>
  );
};

export default Viewer;
